export default "__VITE_ASSET__CK5Kp$u1__"